
import { IVButtonDropDownItem } from "@directives/_core/v-button/v-button.component";
import { IVeriTableBindings } from "@directives/_veri/veriTable/veriTable.component";
import { BroadcastEvent } from "@enums/BroadcastEvent";
import { ConstantsService } from "@services/constantsService";
import { HTMLService } from "@services/htmlService.service";
import { TranslationService } from "@services/translation.service";
import * as angular from "angular";
import "./newResourceFilterBar.scss";

export interface IFilterBar {
    registerFilter(filter: IFilterBarFilter<any>);
}

export interface IFilterBarFilter<T> {
    $element: HTMLElement;

    filterName: string;
    filterLabel: string;
    filterTitle: string;
    filterIcon?: string;

    show: boolean; // Shows dialog
    visible?: boolean; // Visible in list
    isDirty: boolean;

    toggleFilter(show: boolean);
    showClearFilterButton: boolean;
    isInvalid?: boolean;
    clearFilter();

    // Ensure common onChange pattern
    onChange: (args: { filter: T }) => void;
    nextClicked?: () => void;
    prevClicked?: () => void;

    showNextPrev?: boolean;
    disableNext?: boolean;
    disablePrev?: boolean;

    createFilterObject(): T;
    previousFilter: T;

    isPreTranslatedTitle?: boolean;

    // showFilterBy: boolean;
}

interface IComponentBindings {
    isDisabled?: boolean;
    showFilterBy: boolean;
    filterBoxRight?: boolean;
    hideFilterDropdownArrow: boolean;
}

export class ResourceFilterBarComponentController implements angular.IComponentController, IComponentBindings, IFilterBar {

    children: IFilterBarFilter<any>[] = [];
    openChild: IFilterBarFilter<any>;

    popupRight: number;
    showInline: boolean;
    showSettingsCenter: boolean;
    compactView: boolean = false;
    compactViewCenter: boolean = false;
    showFilterLabel: boolean = true;
    showFilterBy: boolean;
    filterBoxRight: boolean;
    isDisabled: boolean = false;
    hideFilterDropdownArrow: boolean = false; supressClose = false;
    newLayout = false;

    dropDownItems: IVButtonDropDownItem<IFilterBarFilter<any>>[] = [];
    showAddFilterDropDown = false;

    isMobile: boolean;

    veriTable: IVeriTableBindings;

    static $inject = ["$rootScope", "$scope", "$timeout", "$element", "$attrs", "$mdMedia", "htmlService", "constantsService", "translationService"];

    constructor(
        private readonly $rootScope: angular.IRootScopeService,
        private readonly $scope: angular.IScope,
        private readonly $timeout: angular.ITimeoutService,
        private readonly $element: angular.IAugmentedJQuery,
        private readonly $attrs: angular.IAttributes,
        private readonly $mdMedia: angular.material.IMedia,
        private readonly htmlService: HTMLService,
        private readonly constantsService: ConstantsService,
        private readonly translationService: TranslationService
    ) {
        console.warn("New Resource Filer Bar is deprecated");
        this.newLayout = $attrs["new"] == "true";
    }

    $onInit() {
        this.setDefaults();

        this.$scope.$on(BroadcastEvent.closeResourceFilterBar, () => {
            this.toggleFilter(null);
        });
    }

    $onDestroy() {
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {

        this.setDefaults();
    }

    registerFilter(filter: IFilterBarFilter<any>) {
        if (!filter.isPreTranslatedTitle) {
            filter.filterName = this.translationService.t(`Common.${filter.filterName.replace(/\s/g, "")}`);
        }        

        this.children.push(filter);

        this.showFilterLabel = this.newLayout || !this.isMobile || this.children.length == 1;

        if (filter.isDirty) {
            this.setChildFilterVisibility(filter, true);
        }

        // A better name for this would be isPermanent or preventRemoval
        // Either way, if we cannot clear this, then it cannot be removed, so dont show on the drop down
        if (filter.showClearFilterButton) {
            this.dropDownItems.push({
                icon: filter.filterIcon,
                label: filter.filterName,
                data: filter
            });

            this.showAddFilterDropDown = true;
        }
    }

    toggleFilter(childFilter: IFilterBarFilter<any>, $event: MouseEvent = null) {
        if (childFilter == this.openChild && this.openChild != null) {
            this.toggleFilter(null, $event);
            return;
        }

        // If we have an existing open filter, then close it and optionally send update
        if (this.openChild && !this.openChild.isInvalid) {
            this.openChild.toggleFilter(false);

            this.sendOnChangeEvent();
        }

        // If we have a new filter to open, then open it and set current state
        if (childFilter) {
            childFilter.previousFilter = childFilter.createFilterObject();
        }

        //console.warn("Here - opening child", childFilter)
        this.openChild = childFilter;

        this.setPopupPosition($event);
        this.broadcast($event);
        this.setVisibilityOnChildren(childFilter == null);
    }

    clearFilter(child: IFilterBarFilter<any>) {
        child = child || this.openChild;

        this.toggleChildFilterVisibility(child);
        child.clearFilter();
        this.toggleFilter(null);
    }

    closeFilter() {
        if (!this.openChild || this.supressClose) {
            return;
        }

        this.toggleFilter(null);

        if (this.newLayout) {
            // Clear up and tidy up NON changed items
            this.children.forEach(c => {
                this.setChildFilterVisibility(c, c.isDirty);
            });
        }
    }

    openFilterPicker($event: MouseEvent) {
        //console.log("openFilterPicker");
        this.$scope.$applyAsync();

        //console.log("showFilterPicker", this.showFilterPicker);

        this.filterBoxRight = false;
        this.setPopupPosition($event);
        this.closeFilter();
    }

    toggleChildFilterVisibility(childFilter: IFilterBarFilter<any>) {
        this.setChildFilterVisibility(childFilter, !childFilter.visible);

        if (childFilter.visible) {
            this.toggleFilter(childFilter);
        }
    }

    private setChildFilterVisibility(childFilter: IFilterBarFilter<any>, visible: boolean) {
        childFilter.visible = visible;

        var matchingDropDownItem = this.dropDownItems.find(i => i.data == childFilter);
        if (matchingDropDownItem) {
            matchingDropDownItem.disabled = childFilter.visible;
        }
    }

    onFilterItemClicked(item: IVButtonDropDownItem<IFilterBarFilter<any>>) {
        this.toggleChildFilterVisibility(item.data);
    }

    // ---

    private setVisibilityOnChildren(delay = false) {

        this.children.forEach(child => {

            child.toggleFilter(false);

            if (delay) {
                this.$timeout(() => {
                    child.$element[0].style.display = "none";
                }, 300);
            }
            else {
                child.$element[0].style.display = "none";
            }
        });

        if (this.openChild && !this.openChild.show) {
            this.openChild.toggleFilter(true);
            this.openChild.$element[0].style.display = "";
        }

        this.$scope.$applyAsync();
    }

    private setPopupPositionBasedOnButton() {

        this.$timeout(() => {

            var allButtons = this.$element.find("v-button");
            var buttonIndex = this.children.indexOf(this.openChild);
            var matchingButton = allButtons[buttonIndex];

            var parent = matchingButton?.parentElement;

            if (!parent || matchingButton.offsetWidth == 0) {
                this.setPopupPositionBasedOnButton();
                return;
            }

            this.popupRight = parent.getBoundingClientRect().right - matchingButton.getBoundingClientRect().right; this.supressClose = false;
        });
    }

    private setPopupPosition($event: MouseEvent) {
        if (!this.openChild) {
            return;
        }

        this.supressClose = true;

        if (!$event) {
            this.setPopupPositionBasedOnButton();
            return;
        }

        var target: HTMLElement = ($event.target || $event.currentTarget) as HTMLElement;
        var filterDropDown = this.htmlService.getParentByTag(target, "div", "filter-drop-down") || target;
        var parent = filterDropDown.parentElement;

        if (this.filterBoxRight) {
            this.popupRight = filterDropDown.offsetLeft - parent.offsetLeft + 5;
        }
        else {
            this.popupRight = parent.offsetWidth - filterDropDown.offsetLeft - filterDropDown.offsetWidth;
        }

        // Strange edge case
        if (this.popupRight == 1) {
            this.popupRight = 0;
        }

        this.supressClose = false;
    }

    private broadcast($event: MouseEvent) {
        if (this.openChild) {
            this.$rootScope.$broadcast(BroadcastEvent.onShowResourceFilterBar, { event: $event });
        }
        else {
            this.$rootScope.$broadcast(BroadcastEvent.onHideResourceFilterBar);
        }
    }

    private sendOnChangeEvent() {
        // Only send updates if there has been changes
        if (!angular.equals(this.openChild.previousFilter, this.openChild.createFilterObject())) {
            var filter = this.openChild.createFilterObject();
            var openChild = this.openChild;

            // This small timeout allows the filter to close properly before (potentially) starting an expensive load operation
            this.$timeout(() => {
                openChild.onChange({ filter: filter });
            }, 0);
        }
    }

    private setDefaults() {
        this.isMobile = this.constantsService.getIsMobile();

        this.showInline = this.showInline === undefined ? true : this.showInline;
        this.showFilterBy = this.showFilterBy === undefined ? !this.isMobile : this.showFilterBy;

        if (this.isMobile) {
            this.showInline = true;
            this.showSettingsCenter = true;
            this.showFilterLabel = false;
        }

        if (this.compactView) {
            this.showFilterLabel = false;
        }

        if (this.compactViewCenter) {
            this.showSettingsCenter = true;
            this.showFilterLabel = false;
        }
    }
}

export class NewResourceFilterBarComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string | angular.Injectable<(...args: any[]) => string>;
    transclude: boolean | { [index: string]: string; };

    constructor() {
        this.bindings = {
            showInline: "<",
            showSettingsCenter: "<",
            compactView: "<",
            compactViewCenter: "<",
            showFilterBy: "<",
            isDisabled: "<?",
            filterBoxRight: "<?",
            hideFilterDropdownArrow: "<?"

        };

        this.controller = ResourceFilterBarComponentController;
        //this.template = require("./newResourceFilterBar.html");

        this.template = ($element: JQuery, $attrs: angular.IAttributes) => {

            if ($attrs["new"] == "true") {
                return require("./newResourceFilterBar2.html");
            }

            return require("./newResourceFilterBar.html");
        }

        this.transclude = true;

        this.template.$inject = ["$element", "$attrs"];
    }
}
